import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/props',
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/MainView.vue'),
  },
  {
    path: '/calls',
    name: 'calls',
    component: () => import('../views/CallsView.vue'),
  },
  {
    path: '/search',
    redirect: '/calls',
  },
  {
    path: '/call/:id',
    name: 'call',
    component: () => import('../views/CallView.vue'),
  },
  {
    path: '/props',
    name: 'props',
    component: () => import('../views/PropsView.vue'),
  },
  {
    path: '/employees',
    name: 'employees',
    component: () => import('../views/EmployeesView.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue'),
  },
  {
    path: '/mapping',
    name: 'mapping',
    component: () => import('../views/MappingView.vue'),
  },
  {
    path: '/stats/token-usage',
    name: 'tokenUsageStats',
    component: () => import('../views/TokenUsageStatsView.vue'),
  },
  {
    path: '/model-configs',
    name: 'modelConfigurations',
    component: () => import('../views/ModelConfigurationsView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
